import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import mylogo from "../assets/img/mylogo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* <MailchimpForm />
          <Col size={12} sm={6}>
           <img src={mylogo} alt="Logo" /> 
          </Col> */}
          <Col size={12} sm={12} className="text-center text-sm-end">
            {/* <div className="social-icon text-right">
              <a href="https://www.linkedin.com/in/sirazul-islam-693506212/"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.facebook.com/sirazulislam.bd.2014?mibextid=ZbWKwL"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://instagram.com/sirazulislam.bd.2014?igshid=NzZlODBkYWE4Ng=="><img src={navIcon3} alt="Icon" /></a>
            </div> */}
            <p className="text-center">Copyright © 2023 Sirazul Islam. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
